import { render } from "./ContentContainer.vue?vue&type=template&id=1ff9e487&scoped=true"
import script from "./ContentContainer.vue?vue&type=script&lang=js"
export * from "./ContentContainer.vue?vue&type=script&lang=js"

import "./ContentContainer.vue?vue&type=style&index=0&id=1ff9e487&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-1ff9e487"]])

export default __exports__